import React from "react"
import PhoneButton from "./PhoneButton"

const SingleProduct = ({ language }) => {
  return (
    <div className="pt-24 flex flex-col justify-between min-h-screen px-8">
      <div className="lg:flex mx-auto ">
        <div className="flex flex-col xs:flex-row">
          <img
            src="/images/wind/1.jpg"
            className="max-h-[250px] sm:max-h-[330px] md:max-h-[400px] mx-auto rounded"
          />
          <img
            src="/images/wind/2.jpg"
            className="max-h-[250px] sm:max-h-[330px] md:max-h-[400px] mx-auto rounded xs:ml-8 mt-4 xs:mt-0"
          />
        </div>
        <div className=" flex flex-col justify-between">
          <div className="lg:ml-16 text-left ">
            <h3 className="mt-6 lg:mt-0 max-w-[500px] lg:max-w-[299px] text-base sm:text-lg md:text-xl ">
              <strong>Вентилятор (кулер) для:</strong> <br /> HP 15-AC, 15-AY,
              15-AF, 15-BA, 15-BS, 15-BW, 250 G4, 255 G4, 250 G5, 255 G5
              (4pin,OEM)
            </h3>
            <p className="text-green-600 mt-4 text-lg md:text-xl ">
              В наявності
            </p>
            <p className=" mt-4  ">Код товару: 1020</p>
            <p className="text-[#002998ef] mt-8 text-3xl md:text-4xl font-bold ">
              243 грн
            </p>
          </div>
          <div className="text-left lg:text-right mt-10 lg:mt-0 lg:mb-2 ">
            <PhoneButton>Замовити</PhoneButton>
          </div>
        </div>
      </div>
      <div className="mt-16"></div>
    </div>
  )
}

export default SingleProduct
